import { FC } from 'react';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Link,
    Typography,
} from '@mui/material';

interface Props {
    open: boolean;
    onClose: () => void;
}

export const LegacyCreateBlockedDialog: FC<Props> = ({ open, onClose }) => (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Event creation has moved to the new apadua platform</DialogTitle>
        <DialogContent>
            <Typography variant="body1" sx={{ mb: 2 }}>
                Creating and publishing new events is no longer possible in the legacy platform.
                Since January 2026, all workspaces and active users have been migrated to the new
                Gen2 platform.
            </Typography>
            <Typography variant="body1">
                Please log in at{' '}
                <Link href="https://apadua.app" target="_blank" rel="noopener noreferrer">
                    apadua.app
                </Link>{' '}
                to create and publish events.
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} variant="contained" color="primary">
                OK
            </Button>
        </DialogActions>
    </Dialog>
);
